import { BrowserRouter, Routes, Route } from 'react-router-dom';
import LoginPage from './components/Login';
import FormPage from './components/form';
import ProtectedRoute from './components/protectedRoute';

function App() {
  return (
    <BrowserRouter basename="/">
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <FormPage />
            </ProtectedRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
